// this is an autogenerated file from App/Account/Content/Settings/Content/Charges/ActionsAction/Content/Content/CopyAction/query.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Charges_ActionsAction_Content_Content_CopyAction($location_ids: [uuid!]!, $charge_ids: [numeric!]!) {
  vaxiom_sys_organizations(where: { _id: { _in: $location_ids } }) {
    id
  }
  vaxiom_misc_fee_charge_templates(where: { id: { _in: $charge_ids } }) {
    id
    name
    price
    insurance_code_id
    affecting_production_report
    is_included_in_insurance_claim
    sys_created
    sys_last_modified
  }
}

`